import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import TextField, { TextFiledType } from '../textField';
import { Visibility } from '../../../types/common-types';
import Menu from '../menu';
import MenuItem from '../menuItem';
import './style.scss';

interface Option {
  value: string;
  title: string;
  visibility?: Visibility;
}
interface SelectProps {
  id?: string;
  value: string;
  error?: boolean;
  label?: string;
  placeholder?: string;
  required?: boolean;
  options: Option[];
  visibility?: Visibility;
  onChange: (value: { id: string; value: string; error: boolean }) => void;
  className?: string;
  styleName?: string;
  helperText?: string;
}

const findActiveTitle = (value: string, options: Option[]) => {
  if (!value || !value.length) {
    return '';
  }
  const findOption = options.find(
    opt => opt.value.toString().toLowerCase() === value.toString().toLowerCase()
  );
  return findOption ? findOption.title : '';
};

const Select: React.FC<SelectProps> = ({
  id = '',
  value,
  error = false,
  label,
  placeholder,
  required = false,
  onChange,
  options = [],
  visibility = Visibility.Visible,
  className,
  helperText,
}) => {
  const [selected, setSelected] = useState(false);
  const [activeTitle, setActiveTitle] = useState('');
  const handleTextFieldFocus = () => {
    setSelected(true);
  };
  const handleMenuClose = () => {
    setSelected(false);
  };
  const handleOnBlur = () => {
    setTimeout(() => {
      if (selected) handleMenuClose();
    }, 500);
  };
  const handleMenuItemClick = (selectedValue: string) => {
    let newError = false;
    if (required && typeof selectedValue === 'undefined') {
      newError = true;
    }
    onChange({ id, value: selectedValue, error: newError });
    setSelected(false);
  };
  useEffect(() => {
    const title = findActiveTitle(value, options);
    setActiveTitle(title);
  }, [value]);
  const renderOptions = () => {
    return options.map(opt => (
      <MenuItem
        key={`${id}_${opt.value}`}
        label={opt.title}
        value={opt.value}
        visibility={opt.visibility}
      />
    ));
  };

  return (
    <div
      id={id}
      styleName={cn('select')}
      className={className}
      data-cy="select"
      onBlur={handleOnBlur}
    >
      <TextField
        className="edit"
        type={TextFiledType.Text}
        label={label}
        placeholder={placeholder}
        value={activeTitle}
        error={error}
        rightIcon="dropdown"
        readOnly
        visibility={visibility}
        helperText={helperText}
        onFocus={handleTextFieldFocus}
      />
      {selected ? (
        <Menu className="menu" onClick={handleMenuItemClick} activeItem={value}>
          {renderOptions()}
        </Menu>
      ) : null}
    </div>
  );
};

export default Select;
